import moment from 'moment'
import packagesSearch from '../../../utils/packages-search'
import getHotelMultiOccParam from '../../../utils/hotel-multi-occ'
import { persistSearchData } from '../../../utils/local-forage'
import {
  FLY,
  HOTEL_AND_CAR,
  FLIGHT_AND_CAR,
  HOTEL_FLIGHT_CAR,
  HOTEL_FLIGHT,
  HOTEL_SEARCH_DATA
} from '../../../constants/Constants'

const hotelRelaxUrl = ({
  locationObject,
  startDate,
  endDate,
  roomCount,
  adultCount,
  childrenAges,
  dealType
}) => {
  const formattedCheckInDate = startDate
    ? moment(startDate).format('YYYYMMDD')
    : ''
  const formattedCheckOutDate = endDate
    ? moment(endDate).format('YYYYMMDD')
    : ''
  let { type: searchType } = locationObject

  const locationName = locationObject.name || locationObject.itemName
  let location = locationObject.id || encodeURIComponent(locationName)

  const dealTypeParam = dealType === 'EXPRESS_DEAL'
    ? '/sopq' : dealType === 'COLLECTIONS'
      ? '/collections' : ''
  let prefHotelAddOnRelax = ''

  if (searchType.toLowerCase() === 'hotel') {
    searchType = 'CITY'
    location = locationObject.cityId
      ? locationObject.cityId
      : locationObject.cityID
    if (!dealTypeParam) {
      prefHotelAddOnRelax = `?preferredhotelids=${locationObject.id}`
    }
  }

  const multiOcc = getHotelMultiOccParam({
    adultCount,
    childrenAges
  })

  const isDatedSearch = startDate && endDate
  if (isDatedSearch) {
    if (searchType.toLowerCase() === 'poi') {
      return `/relax/near/poi/${location}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${roomCount}${dealTypeParam}${multiOcc}`
    } else if (searchType.toLowerCase() === 'airport') {
      return `/relax/near/airport/${location}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${roomCount}${dealTypeParam}${multiOcc}`
    } else {
      return `/relax/in/${location}/from/${formattedCheckInDate}/to/${formattedCheckOutDate}/rooms/${roomCount}${dealTypeParam}${multiOcc}${prefHotelAddOnRelax}`
    }
  } else {
    if (searchType.toLowerCase() === 'poi') {
      return `/relax/near/poi/${location}/rooms/${roomCount}${dealTypeParam}${multiOcc}`
    } else if (searchType.toLowerCase() === 'airport') {
      return `/relax/near/airport/${location}/rooms/${roomCount}${dealTypeParam}${multiOcc}`
    } else {
      return `/relax/in/${location}/rooms/${roomCount}${dealTypeParam}${multiOcc}${prefHotelAddOnRelax}`
    }
  }
}

export const groupDealsURL = ({ locationObject, startDate, endDate }) =>
  `https://findgroupdeals.hotelplanner.com/Priceline.cfm?City=${encodeURIComponent(
    locationObject.itemName
  )}&CheckIn=${encodeURIComponent(
    moment(startDate).format('MM/DD/YYYY')
  )}&CheckOut=${encodeURIComponent(moment(endDate).format('MM/DD/YYYY'))}`

export const formatHotelsURL = ({
  locationObject,
  startDate,
  endDate,
  roomCount,
  adultCount,
  childrenAges,
  dealType
}) => {
  if (Number(roomCount) === 10) {
    return groupDealsURL({
      locationObject,
      startDate,
      endDate,
      roomCount,
      dealType
    })
  } else {
    return hotelRelaxUrl({
      locationObject,
      startDate,
      endDate,
      roomCount,
      adultCount,
      childrenAges,
      dealType
    })
  }
}

const packageTripTypes = [
  HOTEL_AND_CAR,
  FLIGHT_AND_CAR,
  HOTEL_FLIGHT_CAR,
  HOTEL_FLIGHT
]

export const handleSubmitForHotels = ({
  formatURL = formatHotelsURL,
  onSubmit,
  sendSubmitAnalyticsEvent,
  values
}) => {
  const {
    roomCount,
    startDate,
    endDate,
    endLocation,
    endLocationObject,
    locationObject,
    tripType,
    startLocation,
    startLocationObject,
    adultCount,
    childrenCount,
    childrenAges
  } = values

  const multiOccFields = {
    adultCount,
    childrenCount,
    childrenAges
  }

  const isPackageSearch = packageTripTypes.includes(tripType)
  const hasFlight = tripType.includes(FLY)

  if (isPackageSearch) {
    const basePackageSearchDetails = {
      roomCount: Number(roomCount),
      startDate,
      endDate,
      endLocationObject: endLocationObject || locationObject || endLocation,
      tripType,
      isPartialStayDateValid: false,
      ...multiOccFields
    }

    const flightSearchDetails = {
      startLocationObject: startLocationObject || startLocation,
      ...multiOccFields
    }

    const packageSearchDetails = Object.assign({}, basePackageSearchDetails, hasFlight ? flightSearchDetails : {})
    packagesSearch(packageSearchDetails)
  } else {
    const url = formatURL(values)
    if (sendSubmitAnalyticsEvent) {
      sendSubmitAnalyticsEvent(values)
    }
    onSubmit(url)
  }

  persistSearchData(HOTEL_SEARCH_DATA, values)
}
